(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["discover-offers"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('klaviyo-form');
  const listId = 'XPb3Sw';
  
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const email = document.getElementById('k_id_email').value;
      const formWrapper = form.querySelector('.discover-offers__form-wrapper');
      const submitButton = form.querySelector('button[type="submit"]');
      
      
      submitButton.disabled = true;
      submitButton.innerHTML = 'Subscribing...';

    
      const klaviyoEndpoint = `https://manage.kmail-lists.com/subscriptions/subscribe?a=UFtUTP&g=${listId}`;
      
      const data = new FormData();
      data.append('email', email);

      fetch(klaviyoEndpoint, {
        method: 'POST',
        body: data,
        mode: 'no-cors'
      })
      .then(() => {
       
        formWrapper.innerHTML = '<p class="discover-offers__success">Thank you for subscribing!</p>';
      })
      .catch(error => {
        console.error('Error:', error);
        formWrapper.innerHTML = '<p class="discover-offers__error">Something went wrong. Please try again.</p>';
        submitButton.disabled = false;
        submitButton.innerHTML = '{{ section.settings.button_text }}';
      });
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const footer = document.querySelector('.footer');
  const triggers = footer.querySelectorAll('.footer__menu-trigger');
  
  triggers.forEach(trigger => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      
      
      if (window.innerWidth <= 989) {
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        
        
        triggers.forEach(otherTrigger => {
          if (otherTrigger !== trigger) {
            otherTrigger.setAttribute('aria-expanded', 'false');
          }
        });
        
        
        trigger.setAttribute('aria-expanded', !isExpanded);
      }
    });
  });
  

  window.addEventListener('resize', () => {
    if (window.innerWidth > 989) {
      triggers.forEach(trigger => {
        trigger.setAttribute('aria-expanded', 'false');
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  class HeaderController {
    constructor() {
      this.initHeaderAnimation();
      this.initMobileNavigation();
    }

    initHeaderAnimation() {
      // Initialize elements
      this.header = document.querySelector('.header-wrapper');
      this.logo = document.querySelector('.header__heading-logo');
      
      // Initial values
      this.lastScrollTop = 0;
      this.initialLogoWidth = 560;
      this.condensedLogoWidth = 275;
      
      // Add scroll listener
      window.addEventListener('scroll', () => {
        requestAnimationFrame(() => this.handleScroll());
      });

      // Add resize listener
      window.addEventListener('resize', () => {
        requestAnimationFrame(() => this.handleResize());
      });
    }

    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollDistance = Math.min(scrollTop, 200);
      const scrollPercentage = scrollDistance / 200;
      
      // Add/remove condensed class based on scroll position
      if (scrollTop > 50) {
        this.header.classList.add('is-condensed');
      } else {
        this.header.classList.remove('is-condensed');
      }

      // Calculate new logo width based on scroll
      if (window.innerWidth > 749) {
        const newWidth = this.initialLogoWidth - ((this.initialLogoWidth - this.condensedLogoWidth) * scrollPercentage);
        this.logo.style.maxWidth = `${newWidth}px`;
      }

      this.lastScrollTop = scrollTop;
    }

    handleResize() {
      // Reset logo size on mobile
      if (window.innerWidth <= 749) {
        this.logo.style.maxWidth = '';
      } else {
        // Recalculate logo size for desktop
        this.handleScroll();
      }
    }

    initMobileNavigation() {
      this.drawer = document.getElementById('mobile-nav');
      this.menuButton = document.querySelector('.mobile-menu-button');
      this.closeButton = document.querySelector('.mobile-navigation__close');
      this.overlay = document.querySelector('.mobile-navigation__overlay');
      this.triggers = document.querySelectorAll('.mobile-navigation__trigger, .mobile-navigation__subtrigger');
      
      this.bindMobileNavEvents();
    }

    bindMobileNavEvents() {
      if (this.menuButton) {
        this.menuButton.addEventListener('click', () => this.toggleDrawer());
      }

      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => this.toggleDrawer());
      }

      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.toggleDrawer());
      }

      this.triggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => this.handleTriggerClick(e));
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.drawer.classList.contains('is-active')) {
          this.toggleDrawer();
        }
      });
    }

    toggleDrawer() {
      const isOpen = this.drawer.classList.contains('is-active');
      
      this.drawer.classList.toggle('is-active');
      this.menuButton.setAttribute('aria-expanded', !isOpen);
      document.body.style.overflow = isOpen ? '' : 'hidden';

      // If closing the drawer, reset all submenus
      if (!isOpen) {
        this.resetSubmenus();
      }
    }

    handleTriggerClick(event) {
      event.preventDefault();
      const trigger = event.currentTarget;
      const submenu = trigger.nextElementSibling;
      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

      // Find parent menu level
      const parent = trigger.closest('.mobile-navigation__submenu, .mobile-navigation__menu');
      
      // Close any open sibling menus
      const siblings = parent.querySelectorAll('.mobile-navigation__trigger[aria-expanded="true"], .mobile-navigation__subtrigger[aria-expanded="true"]');
      siblings.forEach(sibling => {
        if (sibling !== trigger) {
          sibling.setAttribute('aria-expanded', 'false');
          const siblingSubmenu = sibling.nextElementSibling;
          if (siblingSubmenu) {
            siblingSubmenu.classList.remove('is-active');
          }
        }
      });

      // Toggle current menu
      trigger.setAttribute('aria-expanded', !isExpanded);
      if (submenu) {
        submenu.classList.toggle('is-active');
      }
    }

    resetSubmenus() {
      const expandedTriggers = this.drawer.querySelectorAll('[aria-expanded="true"]');
      const activeSubmenus = this.drawer.querySelectorAll('.is-active');

      expandedTriggers.forEach(trigger => {
        trigger.setAttribute('aria-expanded', 'false');
      });

      activeSubmenus.forEach(submenu => {
        submenu.classList.remove('is-active');
      });
    }
  }

  // Initialize the controller
  const headerController = new HeaderController();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  initMainBlog();
});

document.addEventListener('shopify:section:load', function(event) {
  if (event.target.querySelector('.main-blog')) {
    initMainBlog();
  }
});

function initMainBlog() {
  const filterButtons = document.querySelectorAll('.main-blog__filter');
  const articleCards = document.querySelectorAll('.article-card');
  
  if (filterButtons.length === 0) return;

  filterButtons.forEach(button => {
    button.addEventListener('click', function() {
      const filterValue = this.getAttribute('data-filter');
      
      // Update active button
      filterButtons.forEach(btn => btn.classList.remove('main-blog__filter--active'));
      this.classList.add('main-blog__filter--active');
      
      // Filter cards
      articleCards.forEach(card => {
        const cardTags = card.getAttribute('data-tags');
        const shouldShow = filterValue === 'all' || (cardTags && cardTags.includes(filterValue));
        
        if (shouldShow) {
          card.classList.remove('hidden');
          card.style.display = 'block';
        } else {
          card.classList.add('hidden');
          setTimeout(() => {
            if (card.classList.contains('hidden')) {
              card.style.display = 'none';
            }
          }, 400);
        }
      });
      
      // Smooth scroll to grid after filter
      const grid = document.querySelector('.main-blog__grid');
      if (grid) {
        grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // Intersection Observer for scroll animations
  if ('IntersectionObserver' in window) {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }
      });
    }, observerOptions);

    articleCards.forEach(card => {
      card.style.opacity = '0';
      card.style.transform = 'translateY(30px)';
      observer.observe(card);
    });
  }

  // Enhanced keyboard navigation
  filterButtons.forEach((button, index) => {
    button.addEventListener('keydown', function(e) {
      let nextIndex;
      
      switch(e.key) {
        case 'ArrowLeft':
          e.preventDefault();
          nextIndex = index === 0 ? filterButtons.length - 1 : index - 1;
          filterButtons[nextIndex].focus();
          break;
        case 'ArrowRight':
          e.preventDefault();
          nextIndex = index === filterButtons.length - 1 ? 0 : index + 1;
          filterButtons[nextIndex].focus();
          break;
        case 'Home':
          e.preventDefault();
          filterButtons[0].focus();
          break;
        case 'End':
          e.preventDefault();
          filterButtons[filterButtons.length - 1].focus();
          break;
      }
    });
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-navigation"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const mobileNav = document.getElementById('mobile-nav');
  const drawer = mobileNav.querySelector('.mobile-navigation__drawer');
  const triggers = mobileNav.querySelectorAll('.mobile-navigation__submenu-trigger');
  const closeButton = mobileNav.querySelector('.mobile-navigation__close');
  const backButton = mobileNav.querySelector('.mobile-navigation__back');
  const backMainButton = mobileNav.querySelector('.mobile-navigation__back-main-button');
  const overlay = mobileNav.querySelector('.mobile-navigation__overlay');
  const menuButton = document.querySelector('.mobile-menu-button');

  // Touch variables
  let touchStartX = 0;
  let touchEndX = 0;
  let currentTranslateX = 0;
  let isDragging = false;

  // Open nav function
  const openNav = () => {
    mobileNav.style.visibility = 'visible';
    mobileNav.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    document.addEventListener('click', handleClickOutside);
    
  };

  // Close nav function
  const closeNav = () => {
    mobileNav.classList.remove('is-active');
    drawer.style.transform = '';
    setTimeout(() => {
      mobileNav.style.visibility = 'hidden';
      document.body.style.overflow = '';
    }, 300);
    document.removeEventListener('click', handleClickOutside);
  
  };

  // Handle click outside
  const handleClickOutside = (event) => {
    if (!drawer.contains(event.target) && !menuButton.contains(event.target)) {
      closeNav();
    }
  };

  // Attach open event to menu button
  if (menuButton) {
    menuButton.addEventListener('click', (e) => {
      e.stopPropagation();
      openNav();
    });
  }

  // Handle submenu toggles
  triggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      const submenu = trigger.closest('.mobile-navigation__item').querySelector('.mobile-navigation__submenu');
      submenu.classList.add('is-active');
      backButton.style.display = 'flex';
    });
  });

  // Back button functionality
  backButton.addEventListener('click', () => {
    const visibleSubmenu = mobileNav.querySelector('.mobile-navigation__submenu.is-active');
    if (visibleSubmenu) {
      visibleSubmenu.classList.remove('is-active');
      visibleSubmenu.classList.add('is-hidden');
      setTimeout(() => {
        visibleSubmenu.classList.remove('is-hidden');
      }, 300);
      
      // Hide back button if no submenus are visible
      const visibleSubmenus = mobileNav.querySelectorAll('.mobile-navigation__submenu.is-active');
      if (visibleSubmenus.length <= 1) {
        backButton.style.display = 'none';
      }
    }
  });
   backMainButton.addEventListener('click', closeNav);
  // Close button and overlay events
  closeButton.addEventListener('click', closeNav);
  overlay.addEventListener('click', closeNav);

  // Touch event handlers
  drawer.addEventListener('touchstart', (e) => {
    touchStartX = e.touches[0].clientX;
    isDragging = true;
    drawer.style.transition = 'none';
  }, { passive: true });

  drawer.addEventListener('touchmove', (e) => {
    if (!isDragging) return;
    
    touchEndX = e.touches[0].clientX;
    const diffX = touchEndX - touchStartX;
    
    // Only allow sliding to the right
    if (diffX > 0) {
      currentTranslateX = diffX;
      drawer.style.transform = `translateX(${currentTranslateX}px)`;
    }
  }, { passive: true });

  drawer.addEventListener('touchend', () => {
    isDragging = false;
    drawer.style.transition = 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)';

    // If dragged more than 100px, close the nav
    if (currentTranslateX > 100) {
      closeNav();
    } else {
      drawer.style.transform = '';
    }
    
    currentTranslateX = 0;
    touchStartX = 0;
    touchEndX = 0;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navigation"] && !Shopify.designMode) return;
  try {
    
class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.lastScrollPos = window.pageYOffset;
    this.isScrollingDown = false;
    this.ticking = false;
    this.header = document.querySelector('.header-wrapper');
    this.headerHeight = this.header ? this.header.offsetHeight : 84;
    this.init();
  }

  init() {
    window.addEventListener('scroll', () => {
      if (window.innerWidth <= 749) return; // Don't affect mobile
      
      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          const currentScrollPos = window.pageYOffset;
          
          // Only hide nav after scrolling past header
          if (currentScrollPos > this.headerHeight) {
            if (currentScrollPos > this.lastScrollPos && !this.isScrollingDown) {
              // Scrolling down
              this.isScrollingDown = true;
              this.classList.add('is-hidden');
            } else if (currentScrollPos < this.lastScrollPos && this.isScrollingDown) {
              // Scrolling up
              this.isScrollingDown = false;
              this.classList.remove('is-hidden');
            }
          } else {
            // Reset when at top
            this.isScrollingDown = false;
            this.classList.remove('is-hidden');
          }
          
          this.lastScrollPos = currentScrollPos;
          this.ticking = false;
        });

        this.ticking = true;
      }
    }, { passive: true });

    // Recalculate header height on resize
    window.addEventListener('resize', () => {
      if (this.header) {
        this.headerHeight = this.header.offsetHeight;
      }
    }, { passive: true });
  }
}

customElements.define('menu-drawer', MenuDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-bar"] && !Shopify.designMode) return;
  try {
    
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    event.preventDefault();
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm, { extends: 'form' });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sell-an-item"] && !Shopify.designMode) return;
  try {
    
class SellForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.fileInput = this.querySelector('#ContactForm-images');
    this.fileLabel = this.querySelector('.file-upload__message');
    this.submitButton = this.querySelector('button[type="submit"]');
    this.termsCheckbox = this.querySelector('#ContactForm-terms');
    
    this.bindEvents();
    this.validateForm();
  }

  bindEvents() {
    if (this.form) {
      this.form.addEventListener('submit', this.handleSubmit.bind(this));
    }

    if (this.fileInput) {
      this.fileInput.addEventListener('change', this.handleFileSelect.bind(this));
    }

    // Add input event listeners for all required fields
    this.querySelectorAll('input[required], select[required], textarea[required]')
      .forEach(field => {
        field.addEventListener('input', this.validateForm.bind(this));
        field.addEventListener('change', this.validateForm.bind(this));
      });

    if (this.termsCheckbox) {
      this.termsCheckbox.addEventListener('change', this.validateForm.bind(this));
    }
  }

  handleSubmit(event) {
    if (!this.validateForm()) {
      event.preventDefault();
      this.showError('Please fill in all required fields');
      return;
    }

    // Disable submit button to prevent double submission
    if (this.submitButton) {
      this.submitButton.disabled = true;
      this.submitButton.classList.add('button--loading');
    }
  }

  handleFileSelect(event) {
    const files = Array.from(event.target.files);
    
    if (files.length === 0) {
      this.fileLabel.textContent = 'No files chosen';
      return;
    }

    // Validate file types and sizes
    const validFiles = files.every(file => {
      const isImage = file.type.startsWith('image/');
      const isUnderLimit = file.size <= 5 * 1024 * 1024; // 5MB limit
      return isImage && isUnderLimit;
    });

    if (!validFiles) {
      this.showError('Please upload only images under 5MB each');
      this.fileInput.value = '';
      this.fileLabel.textContent = 'No files chosen';
      return;
    }

    // Update label with file count
    this.fileLabel.textContent = files.length === 1 
      ? '1 file selected'
      : `${files.length} files selected`;
  }

  validateForm() {
    if (!this.form) return false;

    let isValid = true;
    const requiredFields = this.form.querySelectorAll('[required]');

    requiredFields.forEach(field => {
      if (!field.value) {
        isValid = false;
        field.classList.add('field__input--error');
      } else {
        field.classList.remove('field__input--error');
      }
    });

    // Validate email format
    const emailInput = this.form.querySelector('#ContactForm-email');
    if (emailInput && emailInput.value) {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(emailInput.value)) {
        isValid = false;
        emailInput.classList.add('field__input--error');
      }
    }

    // Validate phone format if provided
    const phoneInput = this.form.querySelector('#ContactForm-phone');
    if (phoneInput && phoneInput.value) {
      const phonePattern = /^[0-9\-\+\(\)\s]*$/;
      if (!phonePattern.test(phoneInput.value)) {
        isValid = false;
        phoneInput.classList.add('field__input--error');
      }
    }

    // Check terms checkbox
    if (this.termsCheckbox && !this.termsCheckbox.checked) {
      isValid = false;
    }

    // Enable/disable submit button based on validation
    if (this.submitButton) {
      this.submitButton.disabled = !isValid;
    }

    return isValid;
  }

  showError(message) {
    const errorContainer = this.querySelector('.form-status-list');
    if (!errorContainer) {
      const newError = document.createElement('div');
      newError.className = 'form-status-list';
      newError.setAttribute('role', 'alert');
      newError.innerHTML = `
        <div class="form-status__message form-status__message--error">
          ${message}
        </div>
      `;
      this.form.prepend(newError);

      // Remove error after 5 seconds
      setTimeout(() => {
        newError.remove();
      }, 5000);
    }
  }
}

customElements.define('sell-form', SellForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-product-main"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const productGallery = {
      init() {
        // Elements
        this.container = document.querySelector('.product__media-gallery');
        if (!this.container) return;

        this.mediaItems = Array.from(document.querySelectorAll('.product__media'));
        this.thumbs = Array.from(document.querySelectorAll('.product__media-thumb'));
        this.prevButton = document.querySelector('.slider-button--prev');
        this.nextButton = document.querySelector('.slider-button--next');
        this.images = Array.from(document.querySelectorAll('.product__image'));

        this.currentIndex = 0;

        this.bindEvents();
        this.setupZoom();
      },

      bindEvents() {
        if (this.prevButton) {
          this.prevButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.navigate('prev');
          });
        }

        if (this.nextButton) {
          this.nextButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.navigate('next');
          });
        }

        this.thumbs.forEach((thumb, index) => {
          thumb.addEventListener('click', (e) => {
            e.preventDefault();
            this.setActiveSlide(index);
          });
        });
      },

      navigate(direction) {
        const totalSlides = this.mediaItems.length;
        this.currentIndex = direction === 'next'
          ? (this.currentIndex + 1) % totalSlides
          : (this.currentIndex - 1 + totalSlides) % totalSlides;

        this.setActiveSlide(this.currentIndex);
      },

      setActiveSlide(index) {
        this.mediaItems.forEach((item, i) => {
          item.classList.toggle('is-active', i === index);
        });

        this.thumbs.forEach((thumb, i) => {
          thumb.classList.toggle('is-active', i === index);
        });

        this.currentIndex = index;
      },

      setupZoom() {
        const overlay = document.createElement('div');
        overlay.className = 'zoom-overlay';
        document.body.appendChild(overlay);

        this.images.forEach(image => {
          image.addEventListener('click', (e) => {
            e.preventDefault();
            this.toggleZoom(image);
          });
        });

        overlay.addEventListener('click', () => {
          const zoomedImage = document.querySelector('.product__image.zoomed');
          if (zoomedImage) this.toggleZoom(zoomedImage);
        });
      },

      toggleZoom(image) {
        const overlay = document.querySelector('.zoom-overlay');
        image.classList.toggle('zoomed');
        overlay.classList.toggle('active');
        document.body.style.overflow = image.classList.contains('zoomed') ? 'hidden' : '';
      }
    };

    productGallery.init();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
 const observer = new IntersectionObserver((entries) => {
   entries.forEach(entry => {
     if (entry.isIntersecting) {
       entry.target.classList.add('visible');
     }
   });
 });

 document.querySelectorAll('.fade-in').forEach((el) => observer.observe(el));
});

  } catch(e) { console.error(e); }
})();
})();
